import { render, staticRenderFns } from "./InventoryLoss.vue?vue&type=template&id=2c5ebfd9&scoped=true"
import script from "./InventoryLoss.vue?vue&type=script&lang=js"
export * from "./InventoryLoss.vue?vue&type=script&lang=js"
import style0 from "./InventoryLoss.vue?vue&type=style&index=0&id=2c5ebfd9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ebfd9",
  null
  
)

export default component.exports